import BConfig from "../../Modules/BConfig";
import BRequest from "../../modules/BRequest";
import BProfileArticlePrioritySection from "./BProfileArticlePrioritySection";
import BTagList from "./BTagList";

export default class BProfileArticleFilter
{
	constructor(el)
	{
		this.el = el;
	}

	static className = () => `profile-article-filter`;
	static selector = () => `.${this.className()}`;
	static loadingClassName = () => `${BProfileArticleFilter.className()}--loading`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("click", event => {
			const selector = `${this.selector()}__tag-button`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				const filter = new this(event.target.closest(this.selector()));
				filter.setLoading();

				const button = event.target.closest(selector);

				const tagList = new BTagList(button.closest(BTagList.selector()));
				tagList.setTag(button.dataset?.tagId);

				let url = BConfig.getRoute("api.v2.education.articles")
					.replace("{userId}", "me")
					;
				const data = {
					tagId: button.dataset?.tagId ?? "",
					includeTemplates: "profileArticleThumbnail",
				};

				BRequest.get(url, data).then(response => {
					filter.unsetLoading();
					filter.getProfileArticlePrioritySections().forEach(el => {
						el.setFromResponse(response);
					});
				});
			}
		});
	}

	setLoading()
	{
		this.el.classList.add(BProfileArticleFilter.loadingClassName());
	}

	unsetLoading()
	{
		this.el.classList.remove(BProfileArticleFilter.loadingClassName());
	}

	getProfileArticlePrioritySections()
	{
		let res = [];
		this.el.querySelectorAll(BProfileArticlePrioritySection.selector()).forEach(el => {
			res.push(new BProfileArticlePrioritySection(el));
		});

		return res;
	}
}
